import { render } from "./OkrElementsEmpty.vue?vue&type=template&id=f5678a3a&scoped=true"
import script from "./OkrElementsEmpty.vue?vue&type=script&lang=js"
export * from "./OkrElementsEmpty.vue?vue&type=script&lang=js"

import "./OkrElementsEmpty.vue?vue&type=style&index=0&id=f5678a3a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5678a3a"]])

export default __exports__